import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { Link } from "react-router-dom";
import styles from "../../styles/global-styles";
import EditIcon from "@material-ui/icons/Edit";
import { Checkbox, Chip, Table, TableBody, TableHead } from "@material-ui/core";
import DeleteProduct from "../core/modals/DeleteProduct";
import StyledTableCell from "../../styles/tableCell";
import NumberFormat from "react-number-format";
import { customDate } from "../../_utils/utils";
import StyleTableRow from "../../styles/styleTableRow";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
    "&:hover": {
      // backgroundColor: "#ccebff !important",
      cursor: "pointer",
    },
  },
  link: styles.editLink,
  deleteLink: styles.deleteLink,
  colorChip: styles.chip,
  storeChip: styles.storeChip,
  siteChip: styles.siteChip,
});

const CashCardDetailRow = (props) => {
  const {
    row: { cash_card, id },
    productRemoved,
    accesorySelected,
    selectedExam,
  } = props;

  const [openCollapsible, setOpenCollapsible] = React.useState(false);
  const [openModal, setOpenModal] = React.useState({});
  const classes = useRowStyles();

  const handleOnClose = () =>
    setOpenModal({ ...openModal, open: false, option: undefined });

  const handleOpenModal = (e, option) => {
    e.preventDefault();
    setOpenModal({ ...openModal, open: true, option });
  };

  const isSelected = (id) => selectedExam.indexOf(id) !== -1;
  const isItemSelected = isSelected(cash_card.id);
  const labelId = `enhanced-table-checkbox-${id}`;

  return (
    <React.Fragment>
      <StyleTableRow
        hover
        role="checkbox"
        aria-checked={isItemSelected}
        tabIndex={-1}
        key={id}
        className={classes.rowSelected}
        selected={isItemSelected}
      >
        <StyledTableCell padding="checkbox">
          <Checkbox
            checked={isItemSelected}
            onClick={() => accesorySelected(cash_card.id)}
            inputProps={{ "aria-labelledby": labelId }}
            color="primary"
          />
        </StyledTableCell>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpenCollapsible(!openCollapsible)}
          >
            {openCollapsible ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {cash_card.id}
        </TableCell>

        <TableCell align="center" style={{ fontWeight: 800, fontSize: 16 }}>
          {cash_card.card_catalogue?.name}
        </TableCell>
        <TableCell align="center">
          {cash_card.card_catalogue?.barCode}
        </TableCell>

        <TableCell align="center">
          <NumberFormat
            value={cash_card.card_catalogue?.amount || 0}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
          />
        </TableCell>

        <TableCell align="center">{customDate(cash_card.createdAt)}</TableCell>
        <TableCell align="center">
          <Chip
            label={cash_card.site?.name || "N/A"}
            className={
              cash_card.site?.id === 1 ? classes.storeChip : classes.siteChip
            }
          />
        </TableCell>
      </StyleTableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={openCollapsible} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table size="medium" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    {/** <StyledTableCell align="center">Lote</StyledTableCell>*/}
                    <StyledTableCell align="center"></StyledTableCell>
                    <StyledTableCell align="center"></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <StyledTableCell style={{ width: 260 }} align="center">
                      <Link
                        to=""
                        className={classes.deleteLink}
                        onClick={(e) => handleOpenModal(e, 2)}
                      >
                        <EditIcon
                          fontSize="small"
                          style={{ paddingTop: 6, color: "red" }}
                        />
                        Eliminar producto
                      </Link>
                    </StyledTableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
          {openModal.open && openModal.option === 2 && (
            <DeleteProduct
              open={openModal.open}
              productRemoved={productRemoved}
              onClose={handleOnClose}
              productId={id}
              detailProduct={cash_card}
            />
          )}
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default CashCardDetailRow;
